var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import AwesomeDebouncePromise from "awesome-debounce-promise";
const SEARCH_PARAM_NAME = "search";
export const CaseSearch = ({ navigate, params }) => {
    const debouncedSearch = AwesomeDebouncePromise(navigate, 500);
    const handleChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        if (event.target.value && event.target.value.length > 0) {
            yield debouncedSearch(Object.assign(Object.assign({}, params), { [SEARCH_PARAM_NAME]: event.target.value, page: undefined }));
        }
        else {
            yield debouncedSearch(Object.assign(Object.assign({}, params), { [SEARCH_PARAM_NAME]: undefined, page: undefined }));
        }
    });
    return (React.createElement("span", null,
        React.createElement(TextField, { variant: "outlined", size: "small", className: "SecondaryBarSearch", "data-test": "search", onChange: (event) => handleChange(event), InputProps: {
                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                    React.createElement(Search, null))),
            } })));
};
